<li class="nav-item mr-2" *ngIf="!_data.deskStopped && _data.configuration['showButtonStopAttentionSupervisor']">
  <button *ngIf="!_data.deskStopped" (click)="stop()" class="nav-link btn btn-danger"><i class="fa fa-stop" aria-hidden="true"></i> {{ "stopAttention" | language }}</button>
</li>

<button *ngIf="_data.deskStopped" (click)="ready()" class="nav-link btn btn-primary d-inline-block"><i class="fa fa-play" aria-hidden="true"></i> {{ "playAttention" | language }}</button>
